import Datadog from '../../utils/trackers/Datadog';

function getPrimaryError(error = {}) {
  if (error.errors && Array.isArray(error.errors) && error.errors[0]) {
    return error.errors[0];
  }

  if (error.response && error.response.errors && Array.isArray(error.response.errors) && error.response.errors[0]) {
    return error.response.errors[0];
  }

  if (error.completeError && error.completeError.errors && Array.isArray(error.completeError.errors) && error.completeError.errors[0]) {
    return error.completeError.errors[0];
  }

  return error;
}

function getFailureReason(error = {}) {
  const normalizedError = getPrimaryError(error) || {};

  return normalizedError.code || normalizedError.message || error.code || error.message || 'unknown_error';
}

function track(eventName, payload = {}) {
  Datadog.addAction(eventName, payload);

  return payload;
}

export function trackAuthLoginPageViewed(context = {}) {
  return track('auth.login.page_viewed', context);
}

export function trackAuthLoginSubmitted(context = {}) {
  return track('auth.login.submitted', {
    method: 'email',
    ...context,
  });
}

export function trackAuthLoginSuccess(context = {}) {
  return track('auth.login.success', {
    method: 'email',
    result: 'success',
    ...context,
  });
}

export function trackAuthLoginFailed(error, context = {}) {
  return track('auth.login.failed', {
    method: 'email',
    failure_reason: getFailureReason(error),
    ...context,
  });
}

export function trackAuthTermsShown(context = {}) {
  return track('auth.terms.shown', context);
}

export function trackAuthSessionChecked(context = {}) {
  Datadog.addAction('auth.session.checked', context);
  return context;
}

export function trackAuthRecoveryComplete(payload = {}) {
   Datadog.addAction('auth.recovery.complete', payload);
   return payload;
}

export function trackAuthSessionCheckFailed(context = {}) {
  Datadog.addAction('auth.session.check_failed', context);
  return context;
}

export function trackAuthTermsAccepted(context = {}) {
  return track('auth.terms.accepted', {
    result: 'success',
    ...context,
  });
}

export function trackAuthTermsDeclined(context = {}) {
  return track('auth.terms.declined', context);
}

export function trackAuthRegisterHandoffSubmitted(context = {}) {
  return track('auth.register.handoff_submitted', context);
}

export function trackAuthRegisterSubmitted(context = {}) {
  return track('auth.register.submitted', {
    method: 'email',
    ...context,
  });
}

export function trackAuthRegisterSuccess(context = {}) {
  return track('auth.register.success', {
    method: 'email',
    result: 'success',
    ...context,
  });
}

export function trackAuthRegisterFailed(error, context = {}) {
  return track('auth.register.failed', {
    method: 'email',
    failure_reason: getFailureReason(error),
    ...context,
  });
}

export function trackAuthPasswordRecoveryEmailSubmitted(context = {}) {
  return track('auth.password_recovery.email_submitted', context);
}

export function trackAuthPasswordRecoveryEmailSent(context = {}) {
  return track('auth.password_recovery.email_sent', {
    result: 'success',
    ...context,
  });
}

export function trackAuthPasswordRecoveryEmailFailed(error, context = {}) {
  return track('auth.password_recovery.email_failed', {
    failure_reason: getFailureReason(error),
    ...context,
  });
}

export function trackAuthLogoutInitiated(context = {}) {
  return track('auth.logout.initiated', context);
}

export function trackAuthLogoutComplete(context = {}) {
  return track('auth.logout.complete', {
    result: 'success',
    ...context,
  });
}

export function trackAuthLogoutFailed(error, context = {}) {
  return track('auth.logout.failed', {
    failure_reason: getFailureReason(error),
    ...context,
  });
}

export function trackAuthAccountSuspended(context = {}) {
  return track('auth.account.suspended', context);
}

export function trackExperienceFreeSelected(context = {}) {
  return track('experience.free.selected', context);
}



// WEBPACK FOOTER //
// ./src/services/datadog/auth.js